import { Download } from "@mui/icons-material";
import {
  Dialog,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { SideNav } from "components";
import { HomeWrapper } from "components/CdBalance/style";
import UploadFile from "components/UploadFile";
import { LargeButton, MainBody, PageTitle, Ptag } from "components/core";
import routes from "components/routes";
import { ButtonWrapper } from "pages/PlanSelection";
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router";
import http from "services/httpService";
import { colors } from "theme";
import { formatToPascalCase } from "utlis/utils";

const HEADERS = [
  "Product Name",
  "File Name",
  // "Invoice",
  "File Status",
  "Error",
  " ",
];
function SuperTaskUploadagain() {
  const [taskId, setTaskId] = useState();
  const [products, setProducts] = useState("");
  const [parentStatus, setParentStatus] = useState();
  const [uploadProduct, setUploadProduct] = useState("");
  const [opens, setOpens] = useState(false);
  const [exlId, setExlId] = useState();
  const [fileLink, setFileLink] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    const eb_data = JSON.parse(localStorage.getItem("eb_selected_values"));
    const product_data = JSON.parse(localStorage.getItem("correct_format"));
    const task_id = localStorage.getItem("supertask_id");
    setTaskId(task_id);
    const new_data = Object.entries(product_data).map(([id, value], index) => {
      var product_name =
        eb_data?.userplans_data[id].product_type?.display_name ||
        eb_data?.userplans_data[id].product_type?.product_type_name;
      value.error = "-";
      value.status = "Pending";
      product_name = formatToPascalCase(product_name);
      value.product_name = product_name;
      return [id, value];
    });
    setProducts(new_data);
  }, []);
  useEffect(() => {
    const apiInterval = setInterval(async () => {
      const task_id = localStorage.getItem("supertask_id");
      try {
        const { data } = await http.get(
          `business/get_taskset_details/?super_task_id=${task_id}`
        );
        const async_tasks = data?.task_set_data?.async_tasks;

        async_tasks.forEach((value) => {
          const status = value.status;
          const error = value.error_file_path;
          const userplan = value.userplan;
          const input_file_link = value.input_file_link;
          const prev_state = products;
          const new_Data = products.reduce((accumulator, current) => {
            if (current[0] === userplan) {
              current[1].status = status;
              current[1].error = error;
              current[1].endorsment_file = input_file_link;
            }
            accumulator.push(current);
            return accumulator;
          }, []);
          setProducts(new_Data);
        });
      } catch (e) {
        console.log(e);
      }
    }, 15000);
    if (parentStatus) {
      clearInterval(apiInterval);
      return;
    }
  }, [products]);
  const DownloadFile = (value) => {
    window.open(value.endorsment_file, true);
  };
  const productStatusRow = useMemo(() => {
    if (!products) return;
    let status_arr = [];
    return products.map(([id, value], index) => {
      status_arr.push(value.status);
      const parent_status = status_arr.every((value) => value === "Success");
      setParentStatus(parent_status);
      return (
        <TableRow key={index}>
          <TableCell component="th" scope="row">
            <Ptag fontSize="14px" textAlign="center">
              {value.product_name}
            </Ptag>
          </TableCell>
          <TableCell
            style={{
              // maxWidth: "150px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <Link
              component="button"
              variant="body2"
              style={{
                fontSize: "14px",
                color: colors.neoFontColor,
                textDecoration: "underline",
              }}
              onClick={() => DownloadFile(value)}
            >
              File.xlsx
            </Link>
          </TableCell>
          <TableCell>
            <Ptag fontSize="14px" textAlign="center">
              {value.status}
            </Ptag>
          </TableCell>
          <TableCell>
            <Ptag fontSize="14px" textAlign="center">
              {value.error}
            </Ptag>
          </TableCell>
          <TableCell>
            {value.status == "Failure" && (
              <LargeButton
                fontSize="14px"
                label="Upload Again"
                style={{ height: "40px" }}
                onClick={() => openUpload(value)}
              />
            )}
          </TableCell>
        </TableRow>
      );
    });
  }, [products]);
  const openUpload = (value) => {
    setUploadProduct(value);
    setOpens(true);
  };
  const uploadAgainApi = async () => {
    setOpens(false);
    const payload = {
      super_task_id: taskId,
      products_data: [
        {
          uhid_file_id: exlId,
          userplan_id: uploadProduct.userplan_id,
        },
      ],
    };
    try {
      const { data } = await http.post(
        "/business/reupload_product_issuance_data/",
        payload
      );
    } catch (e) {
      console.log(e);
    }
  };
  const haldleSubmit = () => {
    console.log("dashboard redirection");
    localStorage.setItem("flow", "FLEX"); //ONLY FOR DASHBOARD REDIRECTION WHERE I WILL RENDER NEW BASE TABLE DATA
    navigate(`/${routes.CARE_DASHBOARD}`);
  };
  return (
    <>
      <SideNav />
      <HomeWrapper
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <PageTitle title="Upload Client IDs" />
          <TableContainer
            sx={{
              fontSize: "100% !important",
              maxWidth: "850px",
            }}
          >
            <Table
              sx={{
                minWidth: 650,
              }}
            >
              <TableHead>
                <TableRow>
                  {HEADERS.map((header, index) => (
                    <TableCell key={index}>
                      <Ptag fontSize="16px" fontWeight="700" textAlign="center">
                        {header}
                      </Ptag>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>{productStatusRow}</TableBody>
            </Table>
          </TableContainer>
        </div>
        {parentStatus && (
          <ButtonWrapper>
            <LargeButton
              onClick={() => haldleSubmit()}
              // disabled={parentStatus}
              fontSize={"16px"}
              borderRadius={"10px"}
              width={"100px"}
              label={"Save & Next"}
              marginTop={"16px"}
            />
          </ButtonWrapper>
        )}
      </HomeWrapper>
      <Dialog
        open={opens}
        onClose={false}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: { borderRadius: "20px", marginLeft: "252px" } }}
      >
        <section
          style={{
            padding: "6rem 8rem",
          }}
        >
          <PageTitle title={uploadProduct.product_name} />
          <UploadFile
            headerMargin="12px 0"
            label="Upload Endoresment File"
            text="Upload File"
            format="excel"
            type="policy_upload_excel"
            onSelect={setExlId}
          />
          <LargeButton
            style={{ marginTop: "5rem" }}
            label="Upload File"
            onClick={uploadAgainApi}
          />
        </section>
      </Dialog>
    </>
  );
}

export default SuperTaskUploadagain;
